import NavTab, { NavTabModel } from '../nav-tab/NavTab';
import styles from '../tabs/Tabs.module.scss';

interface NavTabsProps {
  tabs: NavTabModel[];
  hasBorder?: boolean;
}

export function NavTabs({ tabs, hasBorder = false }: NavTabsProps) {
  return (
    <nav className={`${styles.tabs} ${hasBorder && styles['tabs--border']}`}>
      {tabs.map(({ title, to, isDotted }) => {
        return <NavTab key={title} title={title} to={to} isDotted={isDotted} />;
      })}
    </nav>
  );
}

export default NavTabs;
